import { HeadCell } from '../../../models/TableProps';
import { LiveOrderDetailsHead } from '../../../models/LiveOrderProductProps';

export const LIVE_ORDER_PRODUCTS_HEAD_CELLS: HeadCell<LiveOrderDetailsHead>[] =
    [
        {
            id: 'itemCode',
            disablePadding: false,
            label: 'SKU',
            numeric: false,
            sortable: true,
        },
        {
            id: 'description',
            disablePadding: false,
            label: 'TITLE',
            numeric: false,
            sortable: true,
        },
        {
            id: 'quantity',
            disablePadding: false,
            label: 'QUANTITY',
            numeric: false,
            sortable: false,
        },
        {
            id: 'netUnitPrice',
            disablePadding: false,
            label: 'UNIT_PRICE',
            numeric: false,
            sortable: true,
        },
        {
            id: 'netLineAmount',
            disablePadding: false,
            label: 'NET',
            numeric: false,
            sortable: true,
        },
        {
            id: 'grossPrice',
            disablePadding: false,
            label: 'GROSS',
            numeric: false,
            sortable: false,
        },
    ];
